module.exports = __webpack_public_path__ + "static/logo-f796e3493896c8b388b50902bbdc6422.png";